import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles'

import Logo from 'components/logo/Logo.js.jsx'
import Grid from '@material-ui/core/Grid'

import './header.sass'

const styles = theme => ({
    zindex: {
        zIndex: 1299
    }
});

class HeaderContainer extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { classes } = this.props
        return (
            <div className={'flexible-menu ' + classes.zindex}>
              <div className='rel-menu'>
                <Grid container spacing={0} justify="center" alignItems="center">
                  <Grid item xs={2} sm={2} md={1}>
                  </Grid>
                  <Grid item xs={8} sm={8} md={10}>
                    <Logo url='/' style={{width: '100px', height: '30px'}} />
                  </Grid>
                  <Grid item xs={2} sm={2} md={1}>
                  </Grid>
                </Grid>
              </div>
            </div>
        );
    }
}

HeaderContainer.propTypes = {};

export default withStyles(styles)(HeaderContainer);
